import { render, staticRenderFns } from "./GenresData.vue?vue&type=template&id=1cf37ffd&scoped=true&"
import script from "./GenresData.vue?vue&type=script&lang=js&"
export * from "./GenresData.vue?vue&type=script&lang=js&"
import style0 from "./GenresData.vue?vue&type=style&index=0&id=1cf37ffd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf37ffd",
  null
  
)

export default component.exports